import { GiftGroupsList } from "@components/consumer/daily/giftGroups";
import withPage from "@components/hoc/withPage";
import { FC } from "react";

const GiftGroupsListPage: FC = () => {
    return <GiftGroupsList />
}

export default withPage(GiftGroupsListPage);
